import { type JSX } from "react";
import FormInputComponent from "@via/components/inputs/form-input-component.tsx";
import { requiredValidation } from "@via/utils/form-validators.tsx";

export default function CreateDefaultToken({ control }): JSX.Element {
  return (
    <>
      <FormInputComponent
        control={control}
        name="name"
        label="Token Name"
        placeholder="Enter Token Name"
        validations={requiredValidation("Token Name")}
        showRequiredField
      />
      <FormInputComponent
        control={control}
        name="credentialData.token"
        label="Token"
        placeholder="Enter Your Token"
        validations={requiredValidation("Token")}
        showRequiredField
      />
    </>
  );
}
